module.exports = __webpack_public_path__ + "img/icon-rt-consumption.01c4350e.svg";